<template>
  <b-form-select
    v-bind="$attrs"
    :options="options"
    @change="handleChange"
    v-model="selectedInstallationStatus"
    class="form-control"
  >
    <template #first>
      <b-form-select-option :value="null">
        Status da UC
      </b-form-select-option>
    </template>
  </b-form-select>
</template>

<script>
import { INSTALLATION_STATUS } from '../../installation/constants';

export default {
  props: {
    value: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      selectedInstallationStatus: this.value,
      options: [
        {
          text: INSTALLATION_STATUS.WAITING_CONNECTION,
          value: 'WAITING_CONNECTION',
        },
        { text: INSTALLATION_STATUS.CONNECTING, value: 'CONNECTING' },
        { text: INSTALLATION_STATUS.ACTIVE, value: 'ACTIVE' },
        {
          text: INSTALLATION_STATUS.INACTIVATION_REQUESTED,
          value: 'INACTIVATION_REQUESTED',
        },
        { text: INSTALLATION_STATUS.DISCONNECTED, value: 'DISCONNECTED' },
        { text: INSTALLATION_STATUS.DEBT, value: 'DEBT' },
        {
          text: INSTALLATION_STATUS.DUPLICITY,
          value: 'DUPLICITY',
        },
        {
          text: INSTALLATION_STATUS.ENERGY_REPORT,
          value: 'ENERGY_REPORT',
        },
      ],
    };
  },
  methods: {
    handleChange() {
      this.$emit('input', this.selectedInstallationStatus);
    },
  },
};
</script>
